module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-DS-8a771b3e54f746d82e1808c562fe2059.jpg";